import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./components/Home";
import HomeArabic from "./components/arabic/HomeArabic";
import SearchResults from "./components/SearchResults";
import SearchResultsArabic from "./components/arabic/SearchResultsArabic";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrowseResults from "./components/BrowseResults";
import LearnMore from "./components/Learn-More";
import LearnMoreArabic from "./components/arabic/LearnMoreArabic";
import { useEffect } from "react";
import { trackGoogleAnalyticsPageView } from "./googleAnalytics";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    trackGoogleAnalyticsPageView(path);
  }, [location]);

  const lang = localStorage.getItem("lang");
  const HomeComponent = lang === "ar" ? HomeArabic : Home;
  const SearchResultsComponent =
    lang === "ar" ? SearchResultsArabic : SearchResults;
  const LearnMoreComponent = lang === "ar" ? LearnMoreArabic : LearnMore;
  return (
    <>
      <Routes>
        <Route path="*" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomeComponent />} />
        <Route path="/search-results" element={<SearchResultsComponent />} />
        <Route path="/browse/:kind" element={<BrowseResults />} />
        <Route path="/learn-more" element={<LearnMoreComponent />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default App;
